import React from "react";
import Divider from "@material-ui/core/Divider";

const SignupDivider = () => {
  return <Divider style={{ marginTop: "30px", marginBottom: "10px" }} />;
};

export default SignupDivider;
